"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAgentById = void 0;
const getAgentById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("agent_accounts")
        .select("*")
        .eq("id", id)
        .single();
    if (error) {
        throw new Error(error.message);
    }
    return {
        id: data.id,
        logo: `https://golfsavers.b-cdn.net${JSON.parse(data.config.email.logo).url}`,
        primary: data.type === "PRIMARY",
        secondary: data.type === "SUBSITE",
        external: data.type === "EXTERNAL",
        name: data.name,
        email: data.config.email.contact_email,
        phone: data.config.email.contact_phone,
        credit_card_fees: data.config?.fees?.credit_card_fee,
    };
};
exports.getAgentById = getAgentById;
